import moment from 'moment';

export function TimeFormat(time) {
	return moment(time, 'YYYY-MM-DD[T]HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
}

export function removeEmptyValueObject(obj) {
    for (let propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
}
